<template>
  <div class="edit-guarantor-container">
    <component :is="layout" v-if="ready"></component>
  </div>
</template>
  
<script>
import EditDefault from './EditNormal.vue'
import EditHeNan from './EditHeNan.vue'
export default {
  name: 'EditGuarantor',
  components: {
    EditDefault,
    EditHeNan
  },
  data() {
    return {
      layout: 'EditNormal',
      ready: false,
    };
  },
  mounted() {
    if (this.getConfig('ADD_GUARANTOR_MODE') !== 'HeNan') {
      this.layout = 'EditHeNan'
      this.ready = true
    } else {
      this.layout = 'EditNormal'
      this.ready = true
    }
  },
  methods: {
    getConfig (key) {
      return this.$store.getters.sysConfigs[key]
    },
  },
};
</script>
  
<style lang="less" scoped>

</style>
  